module.exports = __webpack_public_path__ + "media/images/lufthansa/logos/a_star_alliance-0b277d83dd48fa3c557f3fa68efa7e7a.png";